import { z } from 'zod';

/**
 * A timestamp as a response schema reads it: a Date (a Prisma row, parsed
 * before JSON serialization) or an ISO string (already serialized). A Date
 * still serializes to the same ISO string the route sent before.
 *
 * A leaf module on purpose: route files import it, and it must not pull in
 * `user-types` (and through it `@prisma/client` enums), which test files mock.
 */
export const DateOrIsoStringSchema = z.union([z.date(), z.string()]);
